﻿import React, { useEffect, useState } from 'react';
import { DropdownlistWithLabel } from '../../../../Resources/Scripts/_Shared/elements/DropdownlistWithLabel';
import { InputWithLabel } from '../../../../Resources/Scripts/_Shared/elements/InputWithLabel';
import { TwoColumnWrapper } from '../../../../Resources/Scripts/_Shared/elements/ColumnWrapper'

export const VehicleListItem = (props) => {
  const defaultCountryCode = props.defaultCountryCode;
  const countryCodeOptions = props.countryCodeOptions;

  const [rowId, setRowId] = useState(props.isSeasonTicket && props.licensePlate.PlateText ? props.licensePlate.PlateText : "");
  const [selectValue, setSelectValue] = useState(props.licensePlate);
  const [typeTextValueLicensePlate, setTypeTextValueLicensePlate] = useState("");
  const [typeTextValueDescription, setTypeTextValueDescription] = useState("");
  const [numberOfFacilities, setNumberOfFacilities] = useState(props.licensePlate.NumberOfFacilities);
  const [showClear, setShowClear] = useState(props.index != props.length);
  const [countryCode, setCountryCode] = useState({ item: { Name: defaultCountryCode, Id: defaultCountryCode }, required: false, elementType: "select" });
  const originalDisplayText = props.licensePlate.item.Text ?? (props.licensePlate.item.PlateText ?? (props.licensePlate.item != undefined ? (props.licensePlate.item.Text ?? props.licensePlate.item.PlateText) : ""));
  //const displayText = selectValue.Text ?? (selectValue.LicensePlate ?? (selectValue.item != undefined ? (selectValue.item.Text ?? selectValue.item.LicensePlate) : ""));
  const currentId = selectValue.Id ?? selectValue.item.Id;
  let currentOptionIsAddNewLicensePlate = selectValue.IsNewLicensePlate || (selectValue.item && selectValue.item.IsNewLicensePlate);
  let error = props.error && props.error.length > 0 && props.error[0].validation ? props.error.filter(error => error.licensePlate === typeTextValueLicensePlate)[0] : props.error ? props.error : null;

  useEffect(() => {
    const inputField = document.querySelectorAll(".vehicle-list-row")[props.index].querySelector("input");
    if (inputField) inputField.focus();
  }, [selectValue]);

  useEffect(() => {
    handleLicensePlateInputTextValueChange({ text: typeTextValueLicensePlate });
  }, [countryCode]);

  useEffect(() => {
    setShowClear(!props.isSeasonTicket || props.index != props.length);
  }, [props.length]);

  useEffect(() => {
    if (props.showEditingMode) {
      setSelectValue(props.licensePlate);
      setTypeTextValueLicensePlate("");
      setTypeTextValueDescription("");
    }
  }, [props.showEditingMode])

  const handleClear = () => {
    if (typeTextValueLicensePlate) {
      props.handleValueChange(({ item: { Text: typeTextValueDescription, PlateText: typeTextValueLicensePlate, Id: typeTextValueLicensePlate, CountryCode: countryCode.item.Id }}));
    } else {
      props.handleValueChange(selectValue);
    }
    setTypeTextValueLicensePlate("");
    const unSelectedItem = props.unSelectedItem;
    unSelectedItem.Id = rowId;
    setSelectValue(unSelectedItem);
  }

  const handleSelectValueChange = (newValue = undefined) => {
    const currentSelectValue = selectValue;
    const currentInputTypeTextValueLicensePlate = {
      item: { Text: typeTextValueDescription, plateText: typeTextValueLicensePlate, Id: typeTextValueLicensePlate, CountryCode: countryCode.item.Id }
    };
    if (newValue) {
      const newValueItem = newValue.item ? newValue.item : newValue;
      let selectValue = newValueItem;
      setSelectValue(selectValue);
      if (currentInputTypeTextValueLicensePlate.item.Text != undefined && currentInputTypeTextValueLicensePlate.item.Text === "") {
        props.handleValueChange(currentSelectValue, selectValue);
      } else {
        props.handleValueChange(currentInputTypeTextValueLicensePlate, selectValue);
        setTypeTextValueLicensePlate("");
      }
    } else {
      setSelectValue(props.unSelectedItem);
      props.handleValueChange(currentSelectValue);
    }
  }
  const handleLicensePlateInputTextValueChange = (newValue = undefined) => {
    if (error && error.validation) props.setError(props.error.filter(error => error.licensePlate !== typeTextValueLicensePlate));
    if (newValue && (newValue.text || newValue.text === "")) {
      const newValueText = newValue.text.toUpperCase().split(' ').join('');
      const currentValueAsLicensePlate = ({ item: { Description: typeTextValueDescription, PlateText: typeTextValueLicensePlate, Id: (props.isSeasonTicket ? currentId : typeTextValueLicensePlate), index: props.index, CountryCode: countryCode.item.Id } });
      const newValueAsLicensePlate = ({ item: { Text: typeTextValueDescription ? `${newValueText} (${typeTextValueDescription})` : `${newValueText}`, Description: typeTextValueDescription, PlateText: newValueText, index: props.index, Id: (props.isSeasonTicket ? currentId : newValueText), CountryCode: countryCode.item.Id } });
      setTypeTextValueLicensePlate(newValueText);
      props.handleValueChange(currentValueAsLicensePlate, newValueAsLicensePlate);
    }
  }

  const handleDescriptionInputTextValueChange = (newValue = undefined) => {
    if (newValue && (newValue.text || newValue.text === "")) {
      const currentValueAsDescription = ({ item: { Description: typeTextValueDescription, PlateText: typeTextValueLicensePlate, Id: (props.isSeasonTicket ? currentId : typeTextValueLicensePlate), CountryCode: countryCode.item.Id } });
      const newValueAsDescription = ({ item: { Text: `${typeTextValueLicensePlate} (${newValue.text})`, Description: newValue.text, PlateText: typeTextValueLicensePlate, Id: (props.isSeasonTicket ? currentId : typeTextValueLicensePlate), CountryCode: countryCode.item.Id } });
      setTypeTextValueDescription(newValue.text);
      props.handleValueChange(currentValueAsDescription, newValueAsDescription);
    }
  }
  const options = ([...props.licensePlatesOnPermit.sort((a, b) => a.item.PlateText > b.item.PlateText ? 1 : -1), props.addNewLicensePlateItem]);
  const label = props.lang.label + " " + (props.index + 1);

  if (!props.showEditingMode) {
    return (
      <>
        <div className="vehicle-list-row">
          <div className="input-fields">
            <div className="input-fields-half">
              {originalDisplayText && <b>{originalDisplayText ?? "Unknown license plate"}</b> || <span className="pending">&nbsp;</span>}
            </div>
            <div className="input-fields-half text-right">
              {numberOfFacilities ?? ""} {numberOfFacilities ? (numberOfFacilities == 1 ? props.lang.facility : props.lang.facilities) : ""}
            </div>
          </div>
        {/*  <div className="remove-wrapper"></div>*/}
        </div>
        <div className="break"></div>
      </>
    );
  }
  return (
    <>
      <div className="vehicle-list-row">
        <div className="input-fields">
          <div className="input-fields-half">
            <DropdownlistWithLabel
              options={options}
              value={((props.isReserved || props.pooling) && !showClear && !error?.validation) ? { ...selectValue, ...error } : selectValue}
              loading={props.pending}
              setValue={handleSelectValueChange}
              text={label}
              isPermit={props.isSeasonTicket}
              optionIdentifier="PlateText"
              dropdownId={"licensePlateOptions" + props.index}
            />
          </div>
          <div className="input-fields-half"></div>
        </div>
        <div className={((props.isReserved || props.pooling) && showClear) ? "remove-wrapper" : "remove-wrapper remove-wrapper--notvisible"}>
          {((props.isReserved || props.pooling) && showClear) ? <a href="#" className="remove" onClick={() => handleClear()}>{props.lang.clear}</a> : <span className="remove">{props.lang.clear}</span>}
        </div>
      </div>
      {currentOptionIsAddNewLicensePlate &&
        <div className="vehicle-list-row" >
          <div className="input-fields">
            <div className="input-fields-half">
            <TwoColumnWrapper modifier="equal">
              <InputWithLabel
                  maxLength={10}
                  inputType="text"
                  setValue={handleLicensePlateInputTextValueChange}
                  value={error}
                  placeholder={props.lang.registrationnumberplaceholder}
                  text={props.lang.labelfreeinput}
                  autoFocus={true}
                  toUpperCase={true}
                  disabled={props.pending}
              />
                <DropdownlistWithLabel
                  text={props.lang.countrycode}
                  options={countryCodeOptions}
                  optionText="Name"
                  disabled={props.pending}
                  dropdownId="countryCodeOptions"
                  value={countryCode}
                  setValue={setCountryCode} />
              </TwoColumnWrapper>
          </div>
            <div className="input-fields-half">
              <InputWithLabel
                maxLength={255}
                inputType="text"
                setValue={handleDescriptionInputTextValueChange}
                placeholder={props.lang.descriptiontextplaceholder}
                text={props.lang.descriptiontext}
                disabled={props.pending}
              />
            </div>
          </div>
        </div>
      }
      <div className="break"></div>
    </>
  );
}

export default VehicleListItem;